export default {"src":"/_next/static/media/roi-post-primary-school-icon.c2577c85.svg","height":14,"width":15,"blurWidth":0,"blurHeight":0};